$(document).ready(function(){
	$(".tooltip-icon").attr("role","button");
	$(".tooltip-icon").attr("aria-expanded","false");
	$(".tooltip-close").attr("role","button");
	$(".tooltip-icon").on("click keydown",tooltipFocus);
	$(".tooltip-close").on("click keydown",tooltipClose);
});




function tooltipFocus(event){
	if(event.type == "keydown"){
		if(event.keyCode != 13 && event.keyCode != 32){
			return;
		}
		event.preventDefault();
	}
	var tooltipIcon = $(event.target);
	var isShown = tooltipIcon.hasClass("show");
	$(".tooltip-icon").attr("aria-expanded","false");
	$(".tooltip-icon").removeClass("show");

	if(!isShown){
		tooltipIcon.addClass("show");
		tooltipIcon.attr("aria-expanded","true");
	}	
}

function tooltipClose(event){
	
	if(event.type == "keydown"){
		if(event.keyCode == 13){
			event.preventDefault();			
		}else{
			return;
		}

	}
	var tRef = $(event.target);
	var icon = tRef.closest(".tooltip-container").find(".tooltip-icon");
	icon.removeClass("show");
	icon.focus();
	$(".tooltip-icon").attr("aria-expanded","false");	
	
}


// WEBPACK FOOTER //
// ./Frontend/js/modules/tooltip.js